import React, { useRef, useState } from "react";
import "../Home/Home.css";
import Modal from "react-modal";
import { FaLocationDot, FaRegCirclePlay } from "react-icons/fa6";
import { MdSupportAgent } from "react-icons/md";
import { FaCarOn } from "react-icons/fa6";
import { GiReceiveMoney } from "react-icons/gi";

const Home = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [enquiryModalIsOpen, setEnquiryModalIsOpen] = useState(false);
  const [brochureModalIsOpen, setBrochureModalIsOpen] = useState(false);
  const [detailsModalIsOpen, setDetailsModalIsOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = () => {
    videoRef.current.play();
    setIsPlaying(true);
  };

  const openModal = (image) => {
    setSelectedImage(image);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setSelectedImage(null);
  };

  const openEnquiryModal = () => {
    setEnquiryModalIsOpen(true);
  };

  const closeEnquiryModal = () => {
    setEnquiryModalIsOpen(false);
  };

  const openBrochureModal = () => {
    setBrochureModalIsOpen(true);
  };

  const closeBrochureModal = () => {
    setBrochureModalIsOpen(false);
  };

  const openDetailsModal = () => {
    setDetailsModalIsOpen(true);
  };

  const closeDetailsModal = () => {
    setDetailsModalIsOpen(false);
  };

  const images = ["g1.webp", "g2.webp", "g3.webp"];

  return (
    <>
      <section id="home" className="slider-section">
        <div
          id="carouselExampleIndicators2"
          className="carousel slide"
          data-bs-ride="carousel"
          data-bs-interval="2000"
        >
          <div className="carousel-indicators">
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators2"
              data-bs-slide-to={0}
              className="active"
              aria-current="true"
              aria-label="Slide 1"
            />
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators2"
              data-bs-slide-to={1}
              aria-label="Slide 2"
            />
          </div>
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img src="banner1.webp" className="image-slider" alt="banner1" />
            </div>
            <div className="carousel-item">
              <img src="banner2.webp" className="image-slider" alt="banner2" />
            </div>
          </div>
          <button
            className="carousel-control-prev1"
            type="button"
            data-bs-target="#carouselExampleIndicators2"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon" aria-hidden="true" />
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next2"
            type="button"
            data-bs-target="#carouselExampleIndicators2"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon" aria-hidden="true" />
            <span className="visually-hidden">Next</span>
          </button>
          <div className="carousel-overlay">
            <h1>PRE LAUNCH</h1>
            <h2>ACE RESIDENTIAL</h2>
            <p>At Sector 12, Noida Extension</p>
            <p className="group-p">By ACE Group</p>
            <div className="offer-list">
              <div className="offer-div">
                <h3>Special Offers</h3>
                <ul>
                  <li>✓ Luxury Living Redefined at Ace Residential</li>
                  <li>✓ Spacious Living</li>
                  <li>✓ Secure Community</li>
                  <li>✓ All The Modern Amenities Available</li>
                  <li>✓ Exclusive Launch Price Offer</li>
                  <li>✓ Avail Best Offers & Discounts*</li>
                </ul>
              </div>
            </div>
            <p className="price-info">
              Luxurious 3 & 4 BHK Apartments
              <br />
              Starts From 11,500/- Sq.Ft.*
            </p>
            <button className="button-13" onClick={openEnquiryModal}>
              Enquire Now
            </button>
          </div>
        </div>
      </section>

      <Modal
        isOpen={enquiryModalIsOpen}
        onRequestClose={closeEnquiryModal}
        contentLabel="Enquiry Modal"
        className="modal-main2"
      >
        <button className="close-button2" onClick={closeEnquiryModal}>
          ×
        </button>
        <div className="modal-full">
          <div className="modalleft">
            <h4 className="modal-heading">We Promise</h4>
            <div className="modal-logo-left">
              <MdSupportAgent className="modal-logo1" />
              <p className="modal-sub-heading">Instant Call Back </p>
            </div>
            <div className="modal-logo-left">
              <FaCarOn className="modal-logo1" />
              <p className="modal-sub-heading">Free Site Visit</p>
            </div>
            <div className="modal-logo-left">
              <GiReceiveMoney className="modal-logo1" />
              <p className="modal-sub-heading">Unmatched Price</p>
            </div>
          </div>
          <div className="modalright">
            <h2 className="modal-heading">Ace Residential</h2>
            <p className="modal-sub-heading">At Sector 12, Noida Extension</p>
            <form className="modal-form">
              <div className="form-group">
                <label htmlFor="name">Name:</label>
                <input type="text" id="name" name="name" required />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email:</label>
                <input type="email" id="email" name="email" required />
              </div>
              <div className="form-group">
                <label htmlFor="mobile">Mobile:</label>
                <input type="tel" id="mobile" name="mobile" required />
              </div>
              <div className="butt-f">
                <button className="submit-button-f" type="submit">
                  Enquire Now
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
      <section id="overview" className="overview-section">
        <div className="all-overview">
          <h1 className="head">Overview</h1>
          <div className="container">
            <div className="div-cont">
              <h2 className="section-title">Ace Residential</h2>
              <p className="location">At Sector 12, Noida Extension</p>
              <p className="description">
                Welcome to Ace Residential, a brand-new launch project perfectly
                situated in the vibrant heart of Sector 12, Noida Extension.
              </p>
              <p className="highlight">
                Ace Residential: Your Dream Home Awaits in Sector 12, Noida
                Extension. Convenient access to essential amenities, including
                schools, hospitals, shopping centers, and entertainment options.
              </p>
              <p id="br" className="advantages">
                This new development offers the advantage of excellent
                connectivity to major highways and areas, making it an
                attractive option for potential homeowners. The project provides
                easy access to the FNG (Faridabad-Noida-Ghaziabad) Expressway,
                NH-24 (National Highway 24), and Greater Noida, ensuring
                convenient travel and commute for residents. The strategic
                location and the modern amenities likely included in the
                development make it a promising investment opportunity in the
                rapidly growing region of Noida Extension.
              </p>
              <p className="advantages">
                Book your site visit today and see for yourself what makes Ace
                Residential the perfect place to call home. Experience the blend
                of luxury, comfort, and convenience that awaits you!
              </p>
              <div className="overview-button" id="br2">
                <button className="button-89" onClick={openBrochureModal}>
                  Download Brochure
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="about-overview">
          <div className="containerr">
            <p className="location">About ACE Group</p>
            <p className="description">
              Ace Group has made a mark in the real estate sector with its
              unwavering commitment to quality and innovation. Founded in 2010
              by Mr. Ajay Choudhary, the Chairman and Managing Director, the
              group has swiftly grown into a notable multi-crore empire,
              renowned for its future-centric, high-end residential and
              commercial projects. With a 13 year legacy, Ace Group has
              successfully delivered over 15 million sq. ft. of projects,
              including the notable 50 acres of Ace Palm Floors Township.
            </p>
          </div>
        </div>

        <div className="project-highlights">
          <h2>Project Highlights</h2>
          <ul>
            <li>Luxury Living Redefined at Ace Residential</li>
            <li>Gated Community With Controlled Access For Enhanced Safety</li>
            <li>Spacious Living</li>
            <li>
              State-of-the-art Clubhouse With A Range Of Recreational Facilities
            </li>
            <li>
              Designed To Provide Ample Space And Comfort For Families Of All
              Sizes
            </li>
            <li>All The Modern Amenities</li>
            <li>Secure Community</li>
            <li>24/7 security with advanced CCTV surveillance</li>
            <li>
              Convenient Access To Essential Amenities, Including Schools,
              Hospitals, Shopping Centers, And Entertainment Options
            </li>
            <li>
              Strategically Located In Sector 12, Offering Excellent
              Connectivity To Major Hubs In Delhi NCR
            </li>
            <li>Prime Location</li>
          </ul>
        </div>
      </section>

      <Modal
        isOpen={brochureModalIsOpen}
        onRequestClose={closeBrochureModal}
        contentLabel="Brochure Modal"
        className="modal-main2"
      >
        <button className="close-button2" onClick={closeBrochureModal}>
          ×
        </button>
        <div className="modal-full">
          <div className="modalleft">
            <h4 className="modal-heading">We Promise</h4>
            <div className="modal-logo-left">
              <MdSupportAgent className="modal-logo1" />
              <p className="modal-sub-heading">Instant Call Back </p>
            </div>
            <div className="modal-logo-left">
              <FaCarOn className="modal-logo1" />
              <p className="modal-sub-heading">Free Site Visit</p>
            </div>
            <div className="modal-logo-left">
              <GiReceiveMoney className="modal-logo1" />
              <p className="modal-sub-heading">Unmatched Price</p>
            </div>
          </div>
          <div className="modalright">
            <h2 className="modal-heading">Ace Residential</h2>
            <p className="modal-sub-heading">At Sector 12, Noida Extension</p>
            <form className="modal-form">
              <div className="form-group">
                <label htmlFor="name">Name:</label>
                <input type="text" id="name" name="name" required />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email:</label>
                <input type="email" id="email" name="email" required />
              </div>
              <div className="form-group">
                <label htmlFor="mobile">Mobile:</label>
                <input type="tel" id="mobile" name="mobile" required />
              </div>
              <div className="butt-f">
                <button className="submit-button-f" type="submit">
                  Click to Download
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
      <section id="price" className="price-section-main">
        <div className="price-head-div">
          <h1 className="head">Price</h1>
        </div>
        <div className="price-section">
          <table>
            <thead>
              <tr>
                <th>Type</th>
                <th>Carpet Area</th>
                <th>Final Price</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {/* Data for 3 BHK */}
              <tr>
                <td>3 BHK</td>
                <td>2200 Sq. Ft.</td>
                <td>11,500/- Sq.Ft.*</td>
                <td>
                  <button className="button-13" onClick={openDetailsModal}>
                    Get Details
                  </button>
                </td>
              </tr>
              {/* Data for 4 BHK */}
              <tr>
                <td>4 BHK</td>
                <td>2900 Sq. Ft.</td>
                <td>On Request</td>
                <td>
                  <button className="button-13" onClick={openDetailsModal}>
                    Get Details
                  </button>
                </td>
              </tr>
              {/* Data for 4 BHK + Servant Room */}
              <tr>
                <td>4 BHK + Servant Room</td>
                <td>3700 Sq. Ft.</td>
                <td>On Request</td>
                <td>
                  <button className="button-13" onClick={openDetailsModal}>
                    Get Details
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <div className="div-price-image">
            <a className="anc" href="#">
              <div className="darksoul-card2">
                <div className="circle2" />
                <img
                  src="rupi.webp"
                  alt="Dark"
                  width={49}
                  height={60}
                  style={{ zIndex: 0 }}
                />
                <p className="content">Know Price</p>
              </div>
            </a>
          </div>
        </div>
      </section>
      <Modal
        isOpen={detailsModalIsOpen}
        onRequestClose={closeDetailsModal}
        contentLabel="Details Modal"
        className="modal-main2"
      >
        <button className="close-button2" onClick={closeDetailsModal}>
          ×
        </button>
        <div className="modal-full">
          <div className="modalleft">
            <h4 className="modal-heading">We Promise</h4>
            <div className="modal-logo-left">
              <MdSupportAgent className="modal-logo1" />
              <p className="modal-sub-heading">Instant Call Back </p>
            </div>
            <div className="modal-logo-left">
              <FaCarOn className="modal-logo1" />
              <p className="modal-sub-heading">Free Site Visit</p>
            </div>
            <div className="modal-logo-left">
              <GiReceiveMoney className="modal-logo1" />
              <p className="modal-sub-heading">Unmatched Price</p>
            </div>
          </div>
          <div className="modalright">
            <h2 className="modal-heading">Ace Residential</h2>
            <p className="modal-sub-heading">At Sector 12, Noida Extension</p>
            <form className="modal-form">
              <div className="form-group">
                <label htmlFor="name">Name:</label>
                <input type="text" id="name" name="name" required />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email:</label>
                <input type="email" id="email" name="email" required />
              </div>
              <div className="form-group">
                <label htmlFor="mobile">Mobile:</label>
                <input type="tel" id="mobile" name="mobile" required />
              </div>
              <div className="butt-f">
                <button className="submit-button-f" type="submit">
                  Get Price Details
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
      <section id="s&f" className="sfp-section-main">
        <div className="sfp-head-div">
          <h1 className="head">Site & Floor Plan</h1>
        </div>
        <div className="sfp-section">
          <div className="sfp-container">
            <article className="container__item">
              <div class="img-container">
                <img
                  src="2bhk.webp"
                  alt="Site"
                  className="img-sfp"
                  width={800}
                  height={534}
                />
                <div class="img-overlay">
                  <div class="img-text">3 BHK Configuration</div>
                  <div class="caption-2">3 BHK</div>
                </div>
              </div>
            </article>
            <article className="container__item">
              <div class="img-container">
                <img
                  src="3bhk.webp"
                  alt="Site"
                  className="img-sfp"
                  width={800}
                  height={534}
                />
                <div class="img-overlay">
                  <div class="img-text">4 BHK Configuration</div>
                  <div class="caption-2">4 BHK</div>
                </div>
              </div>
            </article>
            <article className="container__item">
              <div class="img-container">
                <img
                  src="m1.webp"
                  alt="Site"
                  className="img-sfp"
                  width={800}
                  height={534}
                />
                <div class="img-overlay">
                  <div class="img-text">Master Plan </div>
                  <div class="caption-1">Its our Master Plan</div>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>
      <section id="amen" className="amenities-section-main">
        <div className="amen-head-div">
          <h1 className="head">Amenities</h1>
        </div>
        <div className="amenities-section">
          <div className="amenities-car">
            <div
              id="carouselExampleFade"
              className="carousel slide carousel-fade"
              data-bs-ride="carousel"
            >
              <div className="carousel-inner">
                <div className="carousel-item active">
                  <div className="div-car">
                    <ul>
                      <li> GATED COMMUNITY</li>
                      <li>24*7 SECURITY</li>
                      <li> OUTDOOR SPACES</li>
                    </ul>
                    <ul>
                      <li>RECEPTIONAL FACILITIES</li>
                      <li> ADVANCED CCTV SURVEILLANCE</li>
                      <li>GYM</li>
                    </ul>
                  </div>
                </div>
                <div className="carousel-item">
                  <div className="div-car">
                    <ul>
                      <li>STATE OF THE ART CLUB HOUSE</li>
                      <li>SWIMMING POOL</li>
                      <li>LANDSCAPED GARDEN</li>
                    </ul>
                    <ul>
                      <li>AMPLE PARKING</li>
                      <li>WATER SUPPLY</li>
                      <li>OUTDOOR SPACES</li>
                    </ul>
                  </div>
                </div>
              </div>
              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#carouselExampleFade"
                data-bs-slide="prev"
              >
                <span
                  className="carousel-control-prev-icon"
                  aria-hidden="true"
                />
                <span className="visually-hidden">Previous</span>
              </button>
              <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#carouselExampleFade"
                data-bs-slide="next"
              >
                <span
                  className="carousel-control-next-icon"
                  aria-hidden="true"
                />
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>
        </div>
      </section>
      <section id="gal" className="gallery-section-main">
        <div className="gal-head-div">
          <h1 className="head">Gallery</h1>
        </div>
        <div className="gallery-section">
          <div className="App1">
            <div className="image-grid">
              {images.map((image, index) => (
                <div key={index} className="image-container">
                  <img
                    src={image}
                    alt={`img-${index}`}
                    onClick={() => openModal(image)}
                  />
                </div>
              ))}
            </div>

            <Modal
              isOpen={modalIsOpen}
              onRequestClose={closeModal}
              contentLabel="Image Modal"
              className="Modal"
              overlayClassName="Overlay"
            >
              <button className="close-button" onClick={closeModal}>
                ×
              </button>
              {selectedImage && (
                <img className="modal-img" src={selectedImage} alt="Selected" />
              )}
            </Modal>
          </div>
        </div>
      </section>
      <section id="loc" className="location">
        <div className="lo-head-div">
          <h1 className="head">Location</h1>
        </div>
        <div className="location-main">
          <div className="responsive-map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3504.902849623612!2d77.33698177549752!3d28.54263967571391!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfb1e47a38eaf%3A0xd383da2f2e43ba89!2sACE%20Group!5e0!3m2!1sen!2sin!4v1718105084213!5m2!1sen!2sin"
              width={600}
              height={450}
              frameBorder={0}
              style={{ border: 0 }}
              allowFullScreen
            />
          </div>
        </div>
        <div className="loc-detail">
          <div className="loc-div1">
            <div className="loc-text">
              <FaLocationDot />
              <p className="text-lo">
                Situated In The Vibrant Heart Of Sector 12, Noida Extension
              </p>
            </div>
            <div className="loc-text">
              <FaLocationDot />
              <p className="text-lo">
                Convenient Access To Essential Amenities, Including Schools,
                Hospitals, Shopping Centers, And Entertainment Options.
              </p>
            </div>
            <div className="loc-text">
              <FaLocationDot />
              <p className="text-lo">
                {" "}
                Connectivity To Major Hubs In Delhi NCR.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section id="vst" className="video-section-main">
        <div className="video-head-div">
          <h1 className="head">Virtual Site Tour</h1>
        </div>
        <div className="video-section">
          <div className="video-container">
            <video ref={videoRef} className="video" onClick={openEnquiryModal}>
              <source src="vi.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            {!isPlaying && (
              <>
                <div className="overlay-text">
                  <h1 className="over-text0">Virtual Tour</h1>
                  <p>Ace Residential at Sector 12, Noida Extension</p>
                </div>

                <button className="play-button" onClick={openEnquiryModal}>
                  <FaRegCirclePlay className="logo-vi" />
                </button>
              </>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
